import { Link, useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-6" data-testid="payment-cancel-page">
      <XCircle size={40} className="text-zinc-500" />
      <p className="font-display text-3xl font-black tracking-tight" data-testid="payment-cancel-label">Payment cancelled.</p>
      <p className="max-w-md text-center text-sm leading-relaxed text-zinc-500">
        No money was charged. You can try again anytime — UPI works too.
      </p>
      <button
        onClick={() => navigate(-1)}
        data-testid="payment-retry-button"
        className="flex items-center gap-2 bg-brand px-8 py-3.5 text-xs font-bold uppercase tracking-widest text-white transition-transform duration-300 hover:scale-95"
      >
        <ArrowLeft size={14} /> Try Again
      </button>
      <Link to="/" className="link-underline text-sm uppercase tracking-widest text-brand">Back to home</Link>
    </div>
  );
}
